<script lang="ts" context="module">
  class Walker {

    readonly progress: Writable<number>;
    private _progress = 0;
    private _progress_id: any;
    private readonly _progress_timeout = 200;
    private readonly _progress_step: number;

    readonly step_timeout: number;
    private nextStep: () => void;
    private interval_id: any;

    readonly is_running: Writable<boolean>;

    constructor (step_timeout: number, nextStep: () => void) { 
      this.step_timeout = step_timeout * 1000;
      this._progress_step = 1 / (this.step_timeout / this._progress_timeout);
      this.nextStep = nextStep;
      this.progress = writable(0);
      this.is_running = writable(false);
    }

    run () {
      console.log('run walker');
      console.time('walker')
      this.interval_id = setInterval(() => {
          console.timeLog('walker');
          this.runProgress();
          this.nextStep();
        }, this.step_timeout
      );
      this.is_running.set(true);
      this.runProgress();
    }

    stop () {
      if (this.interval_id) {
        console.log('stop walker');
        console.timeEnd('walker')
        clearInterval(this.interval_id);
        this.stopProgress();
        delete this.interval_id;
        this.is_running.set(false);
      }
    }

    private runProgress () {
      this.progress.set(this._progress = 0);
      clearInterval(this._progress_id);

      this._progress_id = setInterval(() => {
        this._progress += this._progress_step;
        this.progress.set(this._progress);
        
        if (this._progress >= 1) { 
          this.stopProgress();
        }
      }, this._progress_timeout);
    }
    private stopProgress () {
      this.progress.set(this._progress = 1);
      clearInterval(this._progress_id);
    }
  }

</script>

<script lang="ts">

  import { getContext, onMount } from "svelte";
  import { VisioMapApp } from "../vg/visiomap";
  import NavStep, { type Step } from "./NavStep.svelte";
  import SlideSteps from "./SlideSteps.svelte";
  import BtnControl from "../BtnControl.svelte";
  import UIMessage from "../UIMessage.svelte";
  import { readable, type Writable, type Readable, writable } from "svelte/store";
 
  const app = getContext<VisioMapApp>('app');
  
  const { impl_layer, is_mobile, T } = app;
  const { navigation } = impl_layer.essential;

  let steps: Step[] = [];

  let steps_total: number;
  let active_step: number;
  let route_calculation: Promise<void>;

  const nav_walker = new Walker(5, async () => {
    try {
      const anim = navigation.goToNextInstruction();update();
      await anim;
      if (navigation.currentInstructionIndex == navigation.nbInstructions - 1) {
        nav_walker.stop();
      }
    } catch (error) {
      console.error(error);
      nav_walker.stop();
    }
  });
  const is_running = nav_walker.is_running;

  $: playback_interrupted = steps.length < steps_total && !$is_running;

  function update () {

    const index = navigation.currentInstructionIndex;

    if (!steps[index]) {
      steps = steps.concat({
        index: index,
        icon: navigation.getCurrentInstructionIcon(),
        detail: navigation.getCurrentInstructionDetail(),
      })
    }

    active_step = index;

    console.log(
      `${navigation.currentInstructionIndex}/${navigation.nbInstructions}`,
      steps[index], steps
    );
    
  }

  onMount(() => {
    async function tryRun () {
      try {
        route_calculation = app.computeRoute();
        if (navigation?._currentNavigation?.navigationInstructionRadius) {
          navigation._currentNavigation.navigationInstructionRadius = 100;
        }
        
        // Wait calculation to finish before proceeding
        await route_calculation;

        steps_total = navigation.nbInstructions;

        update();
        nav_walker.run()
 
      } catch (error) {
        console.warn(error);
      }
    }

    tryRun();

    // Stop walker on exit
    return () => nav_walker.stop();  
  });


  async function jumpToStep (step: Step) {
    
    nav_walker.stop();
    
    const delta = step.index - active_step;
    const count = Math.abs(delta);
    const move = delta < 0 ? -1 : 1; 
    
    for (let i = 0; i < count; i++) {
      active_step += move;
      delta < 0 
        ? await navigation.goToPreviousInstruction()
        : await navigation.goToNextInstruction();
    }
  }
  
  function jumpToStepCurry(step: Step) {
    return () => jumpToStep(step);
  }
  
  function jumpToStepEventHandler() {
    return (event: CustomEvent<Step>) => jumpToStep(event.detail);
  }
  
  
</script>

<div class="navigation">
    {#await route_calculation}
      <UIMessage type="info">
        {$T`route_compute`}
      </UIMessage>
    {:then _}
      {#if $is_mobile}
        <SlideSteps {steps} {steps_total} {active_step} progress={nav_walker.progress}
          on:click={(e) => jumpToStep(e.detail)}
          on:keypress={jumpToStepEventHandler} />
      {:else}
        {#each steps as step}
          <NavStep {step} {steps_total} active={step.index == active_step}
            progress={nav_walker.progress}
            on:click={jumpToStepCurry(step)}
            on:keypress={jumpToStepCurry(step)} />
        {/each}
        {#if playback_interrupted}
          <BtnControl width="auto" on:click={() => nav_walker?.run()}>{$T`continue`}</BtnControl>
        {/if}
      {/if}
    {:catch}
      <UIMessage type="warning">
        {$T`route_not_available`}
      </UIMessage>
    {/await}
</div>

<style lang="scss">
  .navigation {
    position: relative;
    /* padding: var(--_p2); */
  }
</style>